export default "__VITE_ASSET__K4nKRso3__"